import DEFAULT_VALUES_LAYER from '../default'

const { page: DEFAULT_PAGE_LAYER, ...rest } = DEFAULT_VALUES_LAYER

export default {
  homepage: {
    ...rest,
    page: {
      ...DEFAULT_PAGE_LAYER,
      pageType: 'homepage',
    },
  },
}
